import clsx from 'clsx'

import { Button } from 'components/common/button/Button'
import { Flex } from 'components/common/flex/Flex'
import { ReactComponent as ProjectIcon } from 'components/quickLinks/assets/project-icon.svg'
import { ReactComponent as StatusIcon } from 'components/quickLinks/assets/status-icon.svg'
import styles from 'components/quickLinks/QuickLinks.module.scss'
import { AnalyticsActionType } from 'types/common/analytics.type'
import { EVENTS, trackAnalytics } from 'utils/analytics'

export const QuickLinks = () => {
  const handleRequestOnWorkfront = () => {
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: EVENTS.PLAYGROUND_QUICKLINKS_REQUESTONWORKFRONT,
    })
    window.open(process.env.REACT_APP_WORKFRONT_REQUEST_URL, '_blank')
  }

  const handleCheckPrioritizationStatus = () => {
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: EVENTS.PLAYGROUND_QUICKLINKS_SEEPROJECT,
    })
    window.open(process.env.REACT_APP_WORKFRONT_PROJECT_PRIORITIZATION_STATUS_URL, '_blank')
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>
          Quick Links
        </h2>
        <p className={styles.description}>
          Follow-ups to the prioritization process
        </p>
        <Flex gap={28} className="lg:flex-row flex-col lg:!items-stretch items-center">
          <Flex align="start" gap={22} className={clsx(styles.section, styles.requestProjectSection)}>
            <ProjectIcon className={styles.sectionIcon} />
            <Flex direction="column" justify="between" gap={16} className={styles.sectionContent}>
              <div>
                <p className={styles.sectionTitle}>
                  Request a Project
                </p>
                <p className={styles.sectionDescription}>
                  {'Submit an intake form on Adobe Workfront to\nget started.'}
                </p>
              </div>
              <div>
                <Button
                  text="Request on Adobe Workfront"
                  onClick={() => {
                    handleRequestOnWorkfront()
                  }}
                />
              </div>
            </Flex>
          </Flex>
          <Flex align="start" gap={22} className={clsx(styles.section, styles.checkStatusSection)}>
            <StatusIcon className={styles.sectionIcon} />
            <Flex direction="column" justify="between" gap={16} className={styles.sectionContent}>
              <div>
                <p className={styles.sectionTitle}>
                  Check Status
                </p>
                <p className={styles.sectionDescription}>
                  See updates and progress of your request.
                </p>
              </div>
              <div>
                <Button
                  text="See Project Prioritization Status"
                  onClick={() => {
                    handleCheckPrioritizationStatus()
                  }}
                />
              </div>
            </Flex>
          </Flex>
        </Flex>
      </div>
    </div>
  )
}
